import { render } from "./Carrousel.vue?vue&type=template&id=8f4d744c&ts=true"
import script from "./Carrousel.vue?vue&type=script&lang=ts"
export * from "./Carrousel.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/vmchs.frontend/vmchs.frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__